import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
// assets
import { screen } from 'components/styles/variables';
import lunchBg from 'public/static/images/about_us/why-lunch.jpg';
import compensationBg from 'public/static/images/about_us/why-compensation.jpg';
import gymBg from 'public/static/images/about_us/why-gym.jpg';
import hardwareBg from 'public/static/images/about_us/why-hardware.jpg';
import healthInsuranceBg from 'public/static/images/about_us/why-health-insurance.jpg';
import ptoBg from 'public/static/images/about_us/why-pto.jpg';

function JoinUsDescription() {
  const { t } = useTranslation();

  return (
    <div className="outer-container">
      <div className="container">
        <div className="row">
          <div className="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
            <div className="message-container">
              <h1>{t('aboutUs.join.joinUs')}</h1>
              {ReactHtmlParser(t('aboutUs.join.reason'))}
            </div>
            <div className="perks clearfix">
              <div className="perks-container lunch">
                <div className="perks-background">
                  <div className="perks-overlay" />
                </div>
                <div className="perks-description">
                  {t('aboutUs.join.food')}
                </div>
              </div>
              <div className="perks-container pto">
                <div className="perks-background">
                  <div className="perks-overlay" />
                </div>
                <div className="perks-description">{t('aboutUs.join.pto')}</div>
              </div>
              <div className="perks-container compensation">
                <div className="perks-background">
                  <div className="perks-overlay" />
                </div>
                <div className="perks-description">
                  {t('aboutUs.join.equity')}
                </div>
              </div>
              <div className="perks-container gym">
                <div className="perks-background">
                  <div className="perks-overlay" />
                </div>
                <div className="perks-description">{t('aboutUs.join.gym')}</div>
              </div>
              <div className="perks-container health-insurance">
                <div className="perks-background">
                  <div className="perks-overlay" />
                </div>
                <div className="perks-description">
                  {t('aboutUs.join.insurance')}
                </div>
              </div>
              <div className="perks-container hardware">
                <div className="perks-background">
                  <div className="perks-overlay" />
                </div>
                <div className="perks-description">
                  {t('aboutUs.join.hardware')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .outer-container {
          padding-bottom: 90px;
        }

        .message-container {
          padding: 85px 0 45px 0;
          font-size: 17px;
        }

        h1,
        h2 {
          font-size: 24px;
          margin: 0 0 18px 0;
          font-weight: 600;
        }

        .perks {
          margin-bottom: 20px;
        }

        .perks-container {
          width: 50%;
          height: 188px;
          position: relative;
          float: left;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .perks-container {
            width: 33%;
          }
        }

        .perks-background {
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          background-size: 250px 188px;
          line-height: 25px;
        }

        .perks-overlay {
          background-color: rgba(0, 0, 0, 0.7);
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
        }

        .perks-description {
          text-transform: uppercase;
          font-size: 18px;
          color: #fff;
          display: table-cell;
          vertical-align: middle;
          text-align: center;
          position: relative;
          height: 188px;
          top: 0;
          padding: 20px;
        }

        @media (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
          .perks-description {
            font-size: 15px;
          }
        }

        .lunch .perks-background {
          background-image: url(${lunchBg});
        }

        .pto .perks-background {
          background-image: url(${ptoBg});
        }

        .compensation .perks-background {
          background-image: url(${compensationBg});
        }

        .gym .perks-background {
          background-image: url(${gymBg});
        }

        .health-insurance .perks-background {
          background-image: url(${healthInsuranceBg});
        }

        .hardware .perks-background {
          background-image: url(${hardwareBg});
        }
      `}</style>
    </div>
  );
}

export default JoinUsDescription;
